export default __webpack_public_path__ + "static/media/Rectangle.fecce9dc.svg";